export enum SettingsType {
    Home = 'home',
    Informate = 'informate',
    Management = 'management',
    Idms = 'idms',
    Profile = 'profile',
    Cdms = 'cdms',
}
